import { Api } from '@monorepo/shared/apiClient';
import {
  DocumentFoldersCacheEvents,
  invalidateDocumentFoldersCache,
} from '@monorepo/shared/cacheRegisters/documents/documentFoldersCacheRegister';
import {
  invalidateOrganizationDocumentsCache,
  OrganizationDocumentsCacheEvents,
} from '@monorepo/shared/cacheRegisters/documents/organizationDocumentsCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseDeleteDocumentFolderParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export const useDeleteDocumentFolder = (
  params?: UseDeleteDocumentFolderParams,
) =>
  useMutation(Api.deleteDocumentFolder, {
    ...params?.config,
    onSuccess: (data, vars) => {
      invalidateDocumentFoldersCache(DocumentFoldersCacheEvents.DELETE, {
        organizationId: vars.organizationId,
      });
      if (vars.moveFilesToFolderId) {
        invalidateOrganizationDocumentsCache(
          OrganizationDocumentsCacheEvents.MOVE,
          {
            organizationId: vars.organizationId,
            folderId: vars.moveFilesToFolderId,
          },
        );
      }
      return params?.config?.onSuccess?.(data, vars);
    },
  });
